// extracted by mini-css-extract-plugin
export default {"header":"VirtualTableHeader-header-BLqeA"};